module.exports = __webpack_public_path__ + "static/media/w2p.6c1acddc.svg";